import React, { Component } from 'react';
import uuid from'react-uuid';
import { toast } from "react-toastify";
import { getAssignableRoles} from "../../../common/services/auth/roleService";
import { getRolesByUser, assignRole, revokeRole } from "../../../common/services/auth/userAccountRoleService";
import Loading from '../../../common/components/loading/loading';
import DualListBox from '../../../common/components/form/dualListBox';
import { withTranslation } from 'react-i18next';

class UserAccountRoles extends Component {

    state = { 
        options: [],
        selected: [],        
        isLoading: true
     } 

     async componentDidMount() {
        const {userAccountId} = this.props;
        const allRoles = await getAssignableRoles();
        const roles = await getRolesByUser(userAccountId);

        this.setState(
            {   
                options: this.mapToOptionsViewModel(allRoles)
                , selected: this.mapToSelectedViewModel(roles)
                , isLoading: false
            });       
    };

    mapToOptionsViewModel(roles) {
        return roles.map(role => (
            {
                value: role.roleId,
                label: role.name
            })
         );
    }

    mapToSelectedViewModel(roles) {
        return roles.map(role => (
                role.roleId
            )
        );
    }

    async handleChange(selected, selection, controlKey)
    {      
        const {userAccountId} = this.props;
        const eventId = uuid();
        
        if(controlKey !== 'available'  && controlKey !== 'selected')
        {
            toast.warning(this.props.t("UnexpectedError"));
            return null;
        }

        // set the initial state,will clean up at the end if there are failures.
        this.setState({selected: selected});

        for (const roleId of selection)
        {
            if(controlKey==="available")
            {
                try
                {
                    await assignRole(userAccountId, {roleId: roleId, eventId: eventId})
                    toast.success(this.props.t("RoleAdded"));
                }
                catch (ex)
                {
                    console.log(ex);
                    var index = selected.indexOf(roleId);
                    delete selected[index];
                    toast.warning(this.props.t("RoleAdditionFailed"));
                }
            }
            else if (controlKey==="selected")
            {
                try
                {
                    await revokeRole(userAccountId, {roleId: roleId, eventId: eventId})
                    toast.success(this.props.t("RoleRevoked"));
                }
                catch (ex)
                {
                    console.log(ex);
                    selected.push(roleId);
                    toast.warning(this.props.t("RoleRevocationFailed"));
                }
            }
        }

        //Clean up with the actual outcome state
        this.setState({selected: selected});
    };

    render() { 
        const {options, selected, isLoading} = this.state;
        const {allowEdit}=  this.props;
        
        if (isLoading) return (<Loading/>);

        return (
            <div>
                <DualListBox canFilter
                    className = "rdl-hide-move-all"
                    disabled= {!allowEdit}
                    options={options}
                    selected={selected}
                    onChange={(selected, selection, controlKey)=>this.handleChange(selected, selection, controlKey)}
                />
            </div>    
        );
    }
}
 
export default withTranslation(["auth"])(UserAccountRoles);